/* ============
 * Storage keys for the auth module
 * ============
 */

export const ACCESS_TOKEN = 'at'
export const ID_TOKEN = 'it'
export const EXPIRES_AT = 'eat'

export default {
  ACCESS_TOKEN,
  ID_TOKEN,
  EXPIRES_AT
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/storage-keys.js